export default __webpack_public_path__ + "static/media/bell.62a709bd.svg";